<template>
  <div class="pricing-ex-table-page">
     <ValidationObserver v-slot="{ handleSubmit }">
       <CForm @submit.prevent="handleSubmit( pricingName && (alertValue==null||isPricDetChangedAfterErr) ? toggleConfirmModal : scrollToTop )">
    <CCard>
      <header class="card-header grey-header d-flex">
        <div class="row flex-flow-column">
          <div class="col">
           <strong  v-if="selectedPricingObj != null||isPricingCreatedOnce">{{ $t("createPricing.updatePricing") }}</strong>

            <strong  v-else>{{ $t("createPricing.createPricing") }}</strong>
          </div>
          <p class="desc">
            {{ $t("createPricing.desc") }}
          </p>
        </div>
        <!-- <CButton
                  @click="navigateToCreatePricing(null)"
                  class="btn align-right btn-lit-blue btn-success"
                >{{ $t("managePricing.new") }}</CButton>-->
        <!-- <button type="button" class="btn align-right btn-lit-blue btn-success">New Tier</button> -->
      </header>

      <CCardBody>
        <CRow v-if="GET_SEL_TIER_NAME&&GET_SEL_TIER_NAME.name" >
         <CCol class="top-tier-name">


                <span>{{ $t("createPricing.tierName")+ ' :' }}   </span>   <span>{{GET_SEL_TIER_NAME.name}}
                  </span>
          </CCol>
            
        </CRow>
        <CRow>
          <CCol col="6" class="mb-10px">
            <label>{{ $t("createPricing.name") }}</label>

            <div ref="pricingName">
              <ValidationProvider
                rules="noInitialSpace|required|max:30"
                name="name"
                v-slot="{ errors }"
              >
                <div class="input-group">
                  <input
                    class="form-control "
                    ref="pName"
                    type="text"
                    v-model="pricingName"
                    :placeholder="$t('createPricing.name')"
                    :label="$t('createPricing.name')"
                    :name="$t('createPricing.name')"
                    @input="onPricDetChange"
                  />
                </div>
                <div>
                  <span  v-if="errors && errors[0]" class="invalid-feedback icon">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <!-- <cTextInputComponent
            
            
              v-model="pricingName"
              :placeholder="$t('createPricing.name')"
              :label="$t('createPricing.name')"
              :name="$t('createPricing.name')"
              rules="required"
            >
            </cTextInputComponent> -->
            </div>
          </CCol>

          <CCol col="6" class="mb-10px">
            <cSector
              v-if="travelFromDate"
              v-model="sector"
              ctrlName="name"
              ctrlCode="code"
              :isShowCode="false"
              :isMultiple="false"
              :isSearchable="true"
              :selValue="sector"
              :label="$t('createPricing.selectSector')"
              @input="initTableData"
            />
          </CCol>
          <CCol md="6" sm="12" xs="12" class="mb-10px">
        <cAirLine
              v-if="travelFromDate"
              v-model="airLine"
              ctrlName="airline_name"
              ctrlCode="airline_code"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="true"
              :selValue="airLine"
              :label="$t('createPricing.selectAirline')"
              @input="initTableData"
            /> 
          </CCol>
          <CCol md="6" sm="12" xs="12" class="datepicker-35lh pt-0 none-shadow border-gray-1px border-none col-form-label">
            <div class="date-picker-box-shadow">
              <div class="date">
                <div class="ext-date-wrapper box-shadow">
                    <label class="typo__label">{{
              $t("createPricing.travelPeriod")
            }}</label>
            <v-md-date-range-picker class="right" v-if="travelFromDate && travelToDate"
     :start-date="travelFromDate?travelFromDate.toString():new Date().toString()"
    :end-date="travelToDate?travelToDate.toString():new Date().toString()"
    :disableBefore="travelFromDate.toString()"
    :autoApply="true"
    :showYearSelect="true"
    :maxYear="getMaxYear()"
    :minYear="getMinYear()"
    @change="onChangeDate"
        :allowPastPresets="false"

  
  >
    <!-- :showPresets="true"
     :presets="presets" -->
  <template slot="input">
     <datePickerInput :fromDate="travelFromDate?travelFromDate:null" :toDate="travelToDate?travelToDate:null" :fromLabel="$t('createPricing.fromLabel')" :toLabel="$t('createPricing.toLabel')"/>
  </template>
</v-md-date-range-picker>
                  </div>
              </div>
            </div>
          


            <!-- <HotelDatePicker
              v-if="travelFromDate && travelToDate"
              :startingDateValue="travelFromDate"
              :endingDateValue="travelToDate"
              :hoveringTooltip="false"
              :displayClearButton="false"
              :singleDaySelection="false"
              @check-in-changed="setFromDate"
              @check-out-changed="setToDate"
              :minNights="0"
              :showYear="true"
              :i18n="assigni18nObjByLang()"
            >
            </HotelDatePicker> -->
          </CCol>
        </CRow>
      </CCardBody>
      
                           

      <div class="body-wrap-pricing">
<!--                 <cPaginationLenOption :paginationWatchLs="createPricingTableWatchList"/>-->

        <cTable
          :items="lsPricingTableItems ? lsPricingTableItems : []"
          :fields="lsPricingTableFields ? lsPricingTableFields : []"
          :tableFilter="false"
          column-filter
          items-per-page-select
          :items-per-page="createPricingTableWatchList.itemsPerPage"
          pagination
          :loading="lsPricingTableItems.length ? false : true"
          responsive
          size="sm"
          class="p-table"
           @filtered-items-change="getFilteredAgentCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
                     :tableWatchList="createPricingTableWatchList"
          
            paginationLenOption
        >
          <!-- <template #over-table>
             <cManageColumns v-if="lsPricingTableFields&&lsPricingTableFields.length>0" :lsFields="lsPricingTableFields" @getFields="onSaveColumns"/>
               <cPaginationLenOption :paginationWatchLs="createPricingTableWatchList"/>

              </template> -->
              <template #sector-header>
            <div class="d-flex align-item-center">
              {{$t('createPricing.sector')}}
              <span >
                          <cHelpTip class="right" :content="$t('helpTip.createPricingSector')"></cHelpTip>
                        </span>
            </div>
          </template>
          <template #sector="{item}">
            <td>
              <span>
                {{ item.sector }}
              </span>
            </td>
          </template>
          <template #no-items-view>
            <div class="text-center my-5">
              <h2>
                {{ $t('createPricing["listEmpty"]') }}
              </h2>
            </div>
          </template>
          <template
            #[pricingClass]="{item,index}"
            v-for="pricingClass in lsPricingClasses"
          >
            <td :key="item[pricingClass].tier_id">
              <div
                @click="
                  setPricingClassObj(item[pricingClass]), togglePricingModal()
                "
              >
              <div  v-if="! item[pricingClass].up_down" class="cel empty">
                  <span class="hover">
                  {{  $t('createPricing.edit')}}
                  </span></div>
                <div v-else class="cel">
                 
                  <div class="wrap">
                    <div class="t">
                      <div class="l"> 
                       
                          
                        <span>{{$t( `createPricing.${item[pricingClass].up_down}`)}}</span>
                        <img  v-if="item[pricingClass].up_down==PRICING_VALUE.MARK_UP" src="@imgPath/img/svg/icons/markup.svg" />
                        <img v-else src="@imgPath/img/svg/icons/markdown.svg" />
                       
                      </div>
                      <div class="r">{{$t( `createPricing.${item[pricingClass].pricing_applicableto}`)}}</div>
                    </div>
                    <div class="st">{{$t( `createPricing.${item[pricingClass].pricing_type}`)}}</div>
                    <div class="a">
                      <div class="w">
                        <div class="l" v-for="(currency,index) in item[pricingClass].pricing.currencies"  :key="index+'cn'" >
                          <span>{{currency.currency}}</span>
                          <span>{{currency.value}}</span><span>{{ item[pricingClass].pricing_type==PRICING_VALUE.PERCENTAGE?'%':'' }}</span>
                        </div>
                        <!-- <div class="r">
                          <span>MMK</span>
                          <span>10000</span>
                        </div> -->
                      </div>
                      <!-- <div class="w">
                                                                      <div class="l">
                                                                        <span>USD</span>
                                                                        <span>10000</span>
                                                                      </div>
                                                                      <div class="r">
                                                                        <span>MMK</span>
                                                                        <span>10000</span>
                                                                      </div>
                                                                    </div> -->
                    </div>
                  </div>
                </div>

                <!-- <span
                                  :class="{ pc: item[pricingClass].up_down }"
                                  v-if="item[pricingClass]"
                                >
                                  {{ getPricingCellStatus(item[pricingClass]) }}
                                </span> -->
              </div>
            </td>
          </template>

          <template
            #[getColumnName(pricingClass)]
            v-for="(pricingClass, priceIndex) in lsPricingClasses"
          >
            <td :key="'PricingFilter' + priceIndex">
              <div class="d-flex select-all-btn">
                <div
                  @click="
                    (selectedPricingClassObj = pricingClass),
                      setPricingClassObj(),
                      togglePricingModal()
                  "
                >
                  {{ $t("createPricing.appAll") }}
                </div>

                <div
                  @click="
                    (selectedPricingClassObj = pricingClass),
                      isClearAllAlert=true
                  "
                >
                  {{ $t("createPricing.clearAll") }}
                </div>
              </div>
            </td>
          </template>
        </cTable>
      </div>
     

 <div class="d-flex justify-content-left">
            <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
          </div>
      <CCardFooter class="d-flex justify-content-end">
       
        <CRow class="d-flex justify-content-end">
          <CCol>
            <CButton color="danger" @click="navToManagePricing(true)">
              {{ $t("createPricing.goBack") }}
            </CButton>
          </CCol>
          <CCol style="white-space: nowrap;">
            <CButton
              class="btn action-c-btn btn-success"
              v-if="selectedPricingObj != null||isPricingCreatedOnce"
              type="submit"
            >
              {{ $t("createPricing.updatePricing") }}
            </CButton>

            <CButton
              class="btn action-c-btn btn-success"
              v-else
              type="submit"
            >
              {{ $t("createPricing.createPricing") }}
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
       </CForm>
     </ValidationObserver>

    <ValidationObserver v-slot="{ handleSubmit }" >  
      <CForm
        @submit.prevent="
           handleSubmit( onApplyAll)
        "
      >
        <CModal
          v-if="showPricingModal && pricingObj"
          :title="$t('pricing.title')"
          :show.sync="showPricingModal"
          centered
          :closeOnBackdrop="false"
          class="bclear-popup"
        >
          <template #header-wrapper>
            <CCardHeader class="position-relative">
              <div class="d-flex ai-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28.354"
                  height="28.022"
                  viewBox="0 0 28.354 28.022"
                >
                  <g
                    id="Group_346"
                    data-name="Group 346"
                    transform="translate(0 -3)"
                  >
                    <g
                      id="Group_230"
                      data-name="Group 230"
                      transform="translate(16.611 17.022)"
                    >
                      <g id="Group_229" data-name="Group 229">
                        <path
                          id="Path_77"
                          data-name="Path 77"
                          d="M302.28,260.2a1.066,1.066,0,1,1,1.218-1.054.554.554,0,1,0,1.108,0,2.2,2.2,0,0,0-1.772-2.1v-.288a.554.554,0,0,0-1.108,0v.288a2.2,2.2,0,0,0-1.772,2.1,2.251,2.251,0,0,0,2.326,2.162,1.066,1.066,0,1,1-1.218,1.055.554.554,0,0,0-1.108,0,2.2,2.2,0,0,0,1.772,2.1v.239a.554.554,0,1,0,1.108,0v-.239a2.2,2.2,0,0,0,1.772-2.1A2.251,2.251,0,0,0,302.28,260.2Z"
                          transform="translate(-299.954 -256.201)"
                          fill="#287dfa"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_232"
                      data-name="Group 232"
                      transform="translate(21.261 15.061)"
                    >
                      <g id="Group_231" data-name="Group 231">
                        <path
                          id="Path_78"
                          data-name="Path 78"
                          d="M387.665,223.448a7.215,7.215,0,0,0-2.947-2.608.554.554,0,1,0-.48,1,6.1,6.1,0,0,1,2.746,8.351.554.554,0,1,0,.978.52,7.207,7.207,0,0,0-.3-7.261Z"
                          transform="translate(-383.924 -220.785)"
                          fill="#287dfa"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_234"
                      data-name="Group 234"
                      transform="translate(19.216 14.408)"
                    >
                      <g id="Group_233" data-name="Group 233">
                        <path
                          id="Path_79"
                          data-name="Path 79"
                          d="M347.591,209h-.037a.554.554,0,0,0,0,1.108h.035a.554.554,0,0,0,0-1.108Z"
                          transform="translate(-347 -209.001)"
                          fill="#287dfa"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_236"
                      data-name="Group 236"
                      transform="translate(11.74 17.936)"
                    >
                      <g id="Group_235" data-name="Group 235">
                        <path
                          id="Path_80"
                          data-name="Path 80"
                          d="M216.565,281.876a6.1,6.1,0,0,1-2.746-8.351.554.554,0,1,0-.978-.52,7.2,7.2,0,0,0,3.244,9.869.554.554,0,1,0,.48-1Z"
                          transform="translate(-212.002 -272.711)"
                          fill="#287dfa"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_238"
                      data-name="Group 238"
                      transform="translate(17.52 27.699)"
                    >
                      <g
                        id="Group_237"
                        data-name="Group 237"
                        transform="translate(0 0)"
                      >
                        <path
                          id="Path_81"
                          data-name="Path 81"
                          d="M316.966,449h-.032a.554.554,0,1,0-.005,1.108h.037a.554.554,0,1,0,0-1.108Z"
                          transform="translate(-316.378 -448.999)"
                          fill="#287dfa"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_240"
                      data-name="Group 240"
                      transform="translate(0 3)"
                    >
                      <g
                        id="Group_239"
                        data-name="Group 239"
                        transform="translate(0 0)"
                      >
                        <path
                          id="Path_82"
                          data-name="Path 82"
                          d="M21.454,12.534a2.542,2.542,0,0,0-.246-.452H22.65a2.547,2.547,0,1,0,0-5.095H18.215A2.546,2.546,0,0,0,16.115,3H2.547a2.547,2.547,0,0,0,0,5.095H6.982a2.54,2.54,0,0,0,0,2.88H5.538a2.546,2.546,0,0,0-1.583,4.541,2.543,2.543,0,0,0,0,3.987,2.543,2.543,0,0,0,0,3.987,2.546,2.546,0,0,0,1.583,4.541h6.526a9.412,9.412,0,1,0,9.39-15.5Zm1.2-4.44a1.44,1.44,0,1,1,0,2.88H9.082a1.44,1.44,0,0,1,0-2.88ZM2.547,6.987a1.44,1.44,0,1,1,0-2.88H16.115a1.44,1.44,0,1,1,0,2.88Zm2.99,5.095H19.106a1.439,1.439,0,0,1,.628.145c-.262-.022-.527-.034-.794-.034a9.385,9.385,0,0,0-6.662,2.769H5.538a1.44,1.44,0,0,1,0-2.88Zm0,3.987h5.793a9.388,9.388,0,0,0-1.423,2.88H5.538a1.44,1.44,0,0,1,0-2.88Zm0,3.987H9.654a9.422,9.422,0,0,0-.034,2.88H5.538a1.44,1.44,0,1,1,0-2.88Zm0,6.867a1.44,1.44,0,1,1,0-2.88H9.846a9.377,9.377,0,0,0,1.329,2.88Zm13.4,2.99a8.307,8.307,0,1,1,8.307-8.307A8.316,8.316,0,0,1,18.939,29.914Z"
                          transform="translate(0 -3)"
                          fill="#287dfa"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <div style="padding-left:15px;">
                  {{ $t("pricing.title") }}
                </div>
              </div>
              <div @click="togglePricingModal()" class="close">
                <img
                  src="@imgPath/img/svg/icons/cross-radius.svg"
                  alt=""
                />
              </div>
            </CCardHeader>
          </template>

          <template #body-wrapper>
            <CCardBody class="pb-0px">
              <div class="wrap">
                <div class="des">
                 {{$t('createPricing.pModalDesc',{buttonText: typeof selectedPricingClassObj == "string"
                      ? $t("createPricing.appAll")
                      : $t("createPricing.ok")})}}
                </div>
                <div class="options-wrap">
                  <div class="option">
                    <label for="" class="title">{{
                      $t("pricing.markUpDwn")
                    }}</label>
                    <div class="input-wrap">
                      <div
                        class="right d-flex"
                        v-for="(category, index) in upDownCategory"
                        :key="'c' + index"
                      >
                        <cRadioButton
                          v-model="pricingObj.updown"
                          class="radio-inline"
                          :value="category.code"
                          :label="category.name"
                          :inline="true"
                          :name="category.name"
                          :selValue="pricingObj.updown"
                          v-on:input="updateUpdownCategory(category)"
                        />
                        <span v-if="category.name=='Mark Up'" class="d-flex align-item-center">
                          <cHelpTip :content="$t('helpTip.createPricingMarkup')"></cHelpTip>
                        </span>
                        <span v-if="category.name=='Mark Down'" class="d-flex align-item-center">
                          <cHelpTip :content="$t('helpTip.createPricingMarkdwn')"></cHelpTip>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="option pricing_type">
                    <label for="" class="title">Pricing Type:</label>
                    <div class="input-wrap">
                      <div
                        class="right d-flex"
                        v-for="(pType, index) in pricingType"
                        :key="'pt' + index"
                      >
                        <cRadioButton
                          v-model="pricingObj.pricingType"
                          class="radio-inline"
                          :name="pType.name"
                          :value="pType.code"
                          :label="pType.name"
                          :inline="true"
                          v-on:input="onPricingTypeChange(pType)"
                          :selValue="pricingObj.pricingType"
                        />
                        <span v-if="pType.name=='Percentage Based'" class="d-flex align-item-center">
                          <cHelpTip :content="$t('helpTip.createPricingPercntBase')" ></cHelpTip>
                        </span>
                        <span v-if="pType.name=='Fixed Amount'" class="d-flex align-item-center">
                          <cHelpTip :content="$t('helpTip.createPricingFixd')" ></cHelpTip>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="option ">
                    <label for="" class="title">{{$t('createPricing.applyPricing')}}</label>
                    <div class="input-wrap">
                      <div
                        class="right"
                        v-for="(pType, index) in pricingApplicableTo"
                        :key="'pa' + index"
                      >
                        <cRadioButton
                          v-model="pricingObj.pricingApplicableTo"
                          class="radio-inline"
                          :disabled="
                            pricingObj.pricingType.value ==
                              PRICING_VALUE.PERCENTAGE &&
                              pType.value == PRICING_VALUE.PER_PASSENGER
                          "
                          :name="pType.name"
                          :value="pType.code"
                          :label="pType.name"
                          :inline="true"
                          v-on:input="onPricingApplicableToChange(pType)"
                          :selValue="pricingObj.pricingApplicableTo"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="option">
                     
                    <label v-if="  pricingObj.pricingType.value == PRICING_VALUE.PERCENTAGE"
                      for=""
                      class="title"
                      
                      >{{$t('createPricing.percentage')}} <span>{{ " % " }}</span>
                    </label>
                    <label v-else
                      for=""
                      class="title"
                     
                      > {{$t('createPricing.amount')}} </label
                    >
                    <div v-if="pricingObj && pricingObj.currencies" class="input">
                                <!-- <ValidationProvider    :rules="getRules()"> -->
                      <cCurrencyBoxes 
                      
                        :currItems="pricingObj.currencies"
                        :rules="getRules()"
                        :isPercentage="
                          pricingObj.pricingType.value == PRICING_VALUE.PERCENTAGE
                            ? true
                            : false
                        "
                      />
                         <!-- </ValidationProvider> -->
                    </div>
                  </div>
                </div>
              </div>
              <CRow>
                <!--                <span>-->
                <!--                  <CCol>{{ $t("pricing.markUpDwn") }}</CCol>-->
                <!--                </span>-->
              </CRow>

              <CRow>
                <!--                <span>-->
                <!--                  <CCol>{{ $t("pricing.amount") }}</CCol>-->
                <!--                </span>-->
                <span>
                  <!--                  <cCurrencyBoxes-->
                  <!--                          :currItems="pricingObj.currencies"-->
                  <!--                          :rules="getRules()"-->
                  <!--                          :isPercentage="-->
                  <!--                      pricingObj.pricingType.name == 'Percentage' ? true : false-->
                  <!--                    "-->
                  <!--                  />-->
                </span>
              </CRow>
            </CCardBody>
          </template>
          <template #footer-wrapper>
            <CCardFooter>
              <div class="d-flex justify-content-end">
                <div class="d-flex ai-center w-100">
                  <div
                    class="delete"
                    v-if="typeof selectedPricingClassObj != 'string'"
                    @click="clearPricingCell(selectedPricingClassObj)"
                  >
                    {{ $t("createPricing.clear") }}
                  </div>
                  <!--                                    <CButton -->
                  <!--                                            v-if="typeof selectedPricingClassObj != 'string'"-->
                  <!--                                            @click="clearPricingCell(selectedPricingClassObj)"-->
                  <!--                                    >-->
                  <!--                                        {{ $t("createPricing.clear") }}-->
                  <!--                                    </CButton>-->
                </div>
                <CButton  type="submit" class="primary-btn"
                 
                >
                  {{
                    typeof selectedPricingClassObj == "string"
                      ? $t("createPricing.appAll")
                      : $t("createPricing.ok")
                  }}
                </CButton>
              </div>
            </CCardFooter>
          </template>
        </CModal>
      </CForm>
    </ValidationObserver>
      <!-- <div class="creat-pricing-modal">
    <CModal
      v-if="showConfirmModal"
      :show.sync="showConfirmModal"
      :backdrop="true"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <template #header-wrapper>
        <div class="d-flex justify-content-center popup-icon "> -->
          <!-- <div class=""> -->
          <!-- <template>
            <CCardHeader> -->
              <!-- <CRow></CRow> -->
              <!-- <CRow>
                   <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="307.6px"
                                     height="498.1px" viewBox="0 0 307.6 498.1" style="enable-background:new 0 0 307.6 498.1;" xml:space="preserve">
<defs>
</defs>
                                    <g>
	<path d="M151.7,0c32.4,0.3,63.3,6.7,91.4,23.3c37.3,22.2,59.3,54.6,63.8,98.2c4.4,42.6-10,78.8-39.7,108.7
		c-15.7,15.8-32.9,30-49.3,45.1c-4.6,4.3-8.9,9-13.2,13.6c-10.7,11.7-13.1,26.2-14,41.2c-1.7,27.4-24.6,44.9-51.3,38.9
		c-16.8-3.7-30.7-20.3-30.6-37.5c0.2-21.3,3-42.4,11.8-61.9c4.9-10.9,11.8-21.5,20.1-30c19.4-20,40-38.9,60.5-57.9
		c31.7-29.3,19.4-73.2-2.5-92.3c-15-13-32.8-17.8-52.4-16.7c-31.3,1.8-48.7,20.8-59.5,48c-2.1,5.4-3.8,11.1-6.7,16.1
		c-12.2,20.9-39.3,23.9-56.8,15.5C3.2,142.7-5.2,121,3.3,99.6C23.7,48.7,60.1,16.1,114,3.8c4.4-1,8.8-1.8,13.3-2.2
		C135.4,0.9,143.5,0.5,151.7,0z"/>
                                        <path d="M150.1,403.3c26.5,0,47.2,21,47.3,47.8c0,26.5-20.9,47.2-47.8,47.1c-26.7,0-47-20.8-47-47.9
		C102.6,424,123.6,403.2,150.1,403.3z"/>
</g>
</svg> -->
                <!-- <img
                  class="success-popup-icon"
                  src="@imgPath/img/svg/icons/tick.svg"
                /> -->
                <!-- <CIcon color="white" name="cil-check" size="lg" /> -->
              <!-- </CRow>
            </CCardHeader>
          </template>
          <br />
          <br /> -->
          <!-- </div> -->
        <!-- </div>
        <div class="d-flex justify-content-center">
          <template></template>
          <br />
          <br />
        </div>
      </template>

      <div class="d-flex justify-content-center alert-msg"> -->
        <!-- <strong style="text-align: center" class="pre-formatted ">
          {{ pricingName }}
        </strong> -->

        <!-- <strong style="text-align: center" class="pre-formatted "> 
          {{$t('createPricing.confirm',{status:selectedPricingTier?$t('createPricing.create',{name:pricingName}):$t('createPricing.update',{name:pricingName})})}}

       
        </strong> -->

        <!-- <CDataTable
          :items="
            lsPricingTableItems
              ? filterPricingList(
                  JSON.parse(JSON.stringify(lsPricingTableItems))
                )
              : []
          "
          :fields="lsPricingTableFields ? lsPricingTableFields : []"
          items-per-page-select
          items-per-page="25"
          pagination
          :loading="lsPricingTableItems ? false : true"
          responsive
        >
          <template #no-items-view>
            <div class="text-center my-5">
              <h2>
                {{ $t("createPricing.listEmpty") }}
              </h2>
            </div>
          </template>
          <template
            #[pricingClass]="{item,index}"
            v-for="pricingClass in lsPricingClasses"
          >
            <td :key="pricingClass.tier_id">
              <div>
                <span
                  :class="{ pc: item[pricingClass].up_down }"
                  v-if="item[pricingClass]"
                >
                  {{ getPricingCellStatus(item[pricingClass]) }}
                </span>
              </div>
            </td>
          </template>
        </CDataTable> -->
        <!-- <p>
                  {{ generatePricingDetails() }}
                </p> -->
      <!-- </div>
      <br />

      <div class="d-flex justify-content-center">
        <div>
          <u>
            <a style="color:Blue;"></a>
          </u>
        </div>
      </div>

      <template #footer-wrapper>
        <CCardBody class="d-flex justify-content-end pt-0px">
          <div>
            <CAlert v-if="alertValue" show color="danger">
              {{ alertValue }}
            </CAlert>
          </div>
          <div>
            <CRow class="confirm-btn-wrapper">
              <CCol class="removewrap mb-3 mb-xl-0">
                <CButton
                  aria-pressed="true"
                  class="btn action-c-btn btn-success m-auto curve-border"
                  @click="toggleConfirmModal()"
                >
                  {{ $t("createPricing.cancel") }}
                </CButton>
              </CCol>
              <CCol class="removewrap mb-3 mb-xl-0">
                <CButton
                  v-if="selectedPricingTier != null"
                  aria-pressed="true"
                  class="btn action-c-btn btn-success m-auto curve-border"
                  @click.once="onCreatePricing()"
                >
                  {{ $t("createPricing.createPricing") }}
                </CButton>

                <CButton
                  v-else
                  aria-pressed="true"
                  class="btn action-c-btn btn-success m-auto curve-border"
                  @click.once="updatePricng()"
                >
                  {{ $t("createPricing.updatePricing") }}
                </CButton>
              </CCol>
            </CRow>
          </div>
        </CCardBody> -->
        <!-- </div> -->
        <!-- </div>  -->
      <!-- </template>
    </CModal>
      </div> -->
      <cAlertModal
      :key="'confirm'"
      v-if="showConfirmModal"
      :show="showConfirmModal"
      :buttonList="getConfirmModalBtn()"
      :status="2"
      
      :desc="
        $t('createPricing.confirm',{status:selectedPricingTier?$t('createPricing.create',{name:pricingName}):$t('createPricing.update',{name:pricingName})})"
    >
    </cAlertModal>
    <cAlertModal
      v-if="showAlertModal"
        :key="'alert'"
      :show="showAlertModal"
      :buttonList="getAlertModalBtn()"
      :status="1"
      :desc="
        selectedPricingObj
          ? $t('createPricing.updateStatus')
          : $t('createPricing.createStatus')"
    >
    </cAlertModal>

    <cAlertModal v-if="isClearAllAlert"
            :buttonList="[{
              name:$t('systemTopUpPage.noBtn'),func:onClearAllReject,color:'danger'},
                {name:$t('systemTopUpPage.yesBtn'),func:onClearAll,color:'success'},]"
            :status="2"
            :show="isClearAllAlert"
            :desc="$t('createPricing.clearAllConfmDesc')"
         
          ></cAlertModal>

          <cAlertModal v-if="isApplyAllAlert"
            :buttonList="[{
              name:$t('systemTopUpPage.noBtn'),func:onApplyAllReject,color:'danger'},
                {name:$t('systemTopUpPage.yesBtn'),func:onPricingFormValidated,color:'success'},]"
            :status="2"
            :show="isApplyAllAlert"
            :desc="$t('createPricing.applyAllConfmDesc')"
         
          ></cAlertModal>
  </div>
</template>

<script>
import router, { navigate, goBack ,renewJWT, updateDataEdited} from "./../../router/index";
import { addDays, formatDate, isPastDate } from "./../../util/date/dateFunctions";
import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  SECTOR_TYPE,DATE_TIME_FORMAT,
  PRICING_VALUE,DEFAULT_PRICING
} from "./../../util/constants";
import apiGetPricingSectors from "./../../services/apiGetPricingSectors";
import apiCreatePricing from "./../../services/apiCreatePricing";
import apiUpdatePricing from "./../../services/apiUpdatePricing";
import apiPricingClasses from "./../../services/apiPricingClasses";
import apiGetPricingByPricingId from "./../../services/apiGetPricingByPricingId";
import apiGetOrgCurrencyLs from "./../../services/apiGetOrgCurrencyLs";
import Logger from "./../../services/logger";
//import flightDatePicker from "vue-flight-datepicker";
import HotelDatePicker from "vue-range-datechooser";
import cSector from "../../components/pricing/cSector";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import cAlertModal from "../../components/form/cAlertModal";
import cAirLine from "../../components/pricing/cAirLine";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import {parseNumber, handleJWT, getErrorAlertValue, cloneData ,addClassToBody,removeClassBody, cloneDeep} from "../../util/util";
import BaseConfiguration from "../../config/base";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";

import cRadioButton from "../../components/form/cRadioButton";

import cCurrencyBoxes from "../../components/currency/cCurrencyBoxes";
// import nb from "../../translations/validation/nb.json";
// import en from "../../translations/validation/en.json";
import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
import {VMdDateRangePicker}from "material-vue-date-picker";
    import datePickerInput from "../../components/datePicker/datePickerInput";
    import cFullScreen from "../../components/cFullScreen"
     import cHelpTip from "../../components/cHelpTip"
import cManageColumns from "../../components/dataTable/cManageColumns";
import cTable from "../../components/dataTable/cTable";
                 import moment from "moment";

export default {
  name: COMPONENT_NAME.CREATE_PRICING,

  components: {
    VMdDateRangePicker,
    datePickerInput,
    //flightDatePicker,
    HotelDatePicker,
    cSector,
    ValidationProvider,
    ValidationObserver,
    cRadioButton,
    cTextInputComponent,
    cCurrencyBoxes,
    cAirLine,
    cAlertModal,
    cPaginationLenOption,
    cFullScreen,
    cHelpTip,
    cManageColumns,
    cTable
    
  },
  data: () => {
    return {
 createPricingTableWatchList:{
      filteredlistCount:null,
      itemsPerPage:25,
       currentPageNum:1
       },
     
      PRICING_VALUE: PRICING_VALUE,
      alertValue: null,
      showConfirmModal: false,
      showPricingModal: false,
      showAlertModal: false,
      travelFromDate: null,
      travelToDate: null,
      referenceDate: null,
      pricingName: null,
      selectedPricingClassObj: null,
      currencyList: [],
      // isPercentage : Boolean,

      upDownCategory: [],
      pricingType: [],
      pricingApplicableTo: [],

      pricingObj: {
        updown: {
          name: null,
          value: null
        },
        pricingType: {
          name: null,
          value: null
        },
        pricingApplicableTo: {
          name: null,
          value: null
        },
        currencies: [
          // {
          //   value: 20,
          //   currency: "MMK"
          // },
          // {
          //   value: 20,
          //   currency: "USD"
          // }
        ]
      },

      sector: {
        name: null,
        code: null
      },
      airLine: {
        airline_code: null,
        airline_name: null,
        logourl: null
      },

      lsPricingTableFields: [],
      lsPricingTableItems: [],
      lsPricingClasses: [],
      lsPricingSectors: [],
      pricingResponse: [],
      isClearAllAlert:false,
      isApplyAllAlert:false,
      isPricingCreatedOnce:false,
      isPricDetChangedAfterErr:true
    //   presets: [
    //     {
    //       label: 'Next 7 days',
    //     range: [
    //       moment(),
    //       moment().add(6, 'day'),
    //     ]
    //   },
    //   {
    //     label: 'Next Week',
    //     range: [
    //       moment().add(7, 'day'),
    //       moment().add(13, 'day'),
    //     ]
    //   },
    //   {
    //     label: 'Next 30 days',
    //     range: [
    //       moment(),
    //       moment().add(30, 'day'),
    //     ]
    //   }
    // ]

    };
  },
  computed: {
    ...mapGetters("sCreatePricing", {
      // GET_PRICING_SECTOR_REQ: "GET_PRICING_SECTOR_REQ",
      // GET_PRICING_SECTOR_RES: "GET_PRICING_SECTOR_RES",
      // GET_PRICING_CLASSES_REQ: "GET_PRICING_CLASSES_REQ",
      // GET_PRICING_CLASSES_RES: "GET_PRICING_CLASSES_RES",
      selectedPricingObj: "GET_SELECTED_PRICING",
      selectedPricingTier: "GET_SELECTED_TIER",
      GET_SEL_TIER_NAME:"GET_SEL_TIER_NAME"
    }),
    ...mapGetters("sCAirLine", { GET_ALL_AIRLINE_RES: "GET_ALL_AIRLINE_RES" }),
    ...mapGetters("sCurrencyLs", {
     GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"

    })
  },
  methods: {


         onPricDetChange() {
             try {
               if(BaseConfiguration.isDebug) console.log("onPricDetChange");
              if(!this.isPricDetChangedAfterErr){
              this.isPricDetChangedAfterErr=true;
              }
         
             } catch (err) {
                     let body = Logger.buildRequest(
                       COMPONENT_NAME.CREATE_PRICING,
                       "error in onPricDetChange",
                       err.toString(),
                       "onPricDetChange",
                       LOG_TYPE.ERROR
                     );
                     Logger.getResponse(body);
                   }
             }, 
         getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CREATE_PRICING,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CREATE_PRICING,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
        onChangeDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
            this.onPricDetChange();
          //  console.error(pDateList)
           this.setFromDate(pDateList[0]._d);
             this.setToDate(pDateList[1]._d);
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CREATE_PRICING,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
     onPaginationChange(pItemsPerPage) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPaginationChange");
           this.createPricingTableWatchList.itemsPerPage=pItemsPerPage;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CREATE_PRICING,
                  "error in onPaginationChange",
                  err.toString(),
                  "onPaginationChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    onPageChange(pPageNum) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPageChange");
    this.createPricingTableWatchList.currentPageNum=pPageNum;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CREATE_PRICING,
                  "error in onPageChange",
                  err.toString(),
                  "onPageChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

    getFilteredAgentCount(pFilteredItems) {
        try {
          if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
         this.createPricingTableWatchList.filteredlistCount=pFilteredItems.length;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CREATE_PRICING,
                  "error in getFilteredAgentCount",
                  err.toString(),
                  "getFilteredAgentCount",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
    onApplyAllReject() {
        try {
          if(BaseConfiguration.isDebug) console.log("onApplyAllReject");
         this.isApplyAllAlert=false;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.CREATE_PRICING,
                  "error in onApplyAllReject",
                  err.toString(),
                  "onApplyAllReject",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         ;
        }, 
      
        onApplyAll() {
            try {
              if(BaseConfiguration.isDebug) console.log("onApplyAll");
            let isNoAlert=   typeof this.selectedPricingClassObj == 'string'
                      ?false
                      : true;
              if(isNoAlert){
          this.onPricingFormValidated();
              }else{
 this.showPricingModal = false;

        this.isApplyAllAlert=true;
              }
       
            } catch (err) {
                    let body = Logger.buildRequest(
                      FILE_NAME.CREATE_PRICING,
                      "error in onApplyAll",
                      err.toString(),
                      "onApplyAll",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
            }, 

    onClearAllReject() {
        try {
          if(BaseConfiguration.isDebug) console.log("onClearAllReject");
        //  this.selectedPricingClassObj = pricingClass;
     this.isClearAllAlert=false;
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.CREATE_PRICING,
                  "error in onClearAllReject",
                  err.toString(),
                  "onClearAllReject",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

        onClearAll() {
            try {
              if(BaseConfiguration.isDebug) console.log("onClearAll");
            
                 this.resetAllSectors( this.selectedPricingClassObj, this.lsPricingTableItems);
                 this.isClearAllAlert=false;

            } catch (err) {
                    let body = Logger.buildRequest(
                     FILE_NAME.CREATE_PRICING,
                      "error in onClearAll",
                      err.toString(),
                      "onClearAll",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
           
            }, 
    scrollToTop() {
      window.scrollTo(0, 0);
      this.$refs.pName.focus();
    },
    getAlertModalBtn() {
      return [
        {
          name: this.$t("createPricing.ok"),
          func: this.navToManagePricing
        }
      ];
    },

     getConfirmModalBtn() {
      return [
        {
          name: this.$t("createPricing.cancel"),
          func: this.toggleConfirmModal
        },
        {
          name: this.$t("createPricing.yes"),
          func: this.selectedPricingTier&&!this.isPricingCreatedOnce ? this.onCreatePricing : this.updatePricng
        }
      ];
    },


    onPricingFormValidated() {
       try {
         if(BaseConfiguration.isDebug) console.log("onPricingFormValidated");

         typeof this.selectedPricingClassObj == 'string'
            ? this.applyToAllSectors(
               this. selectedPricingClassObj,
               this. lsPricingTableItems,
               this. pricingObj
              )
            :this.onPricingFormSubmit(this.selectedPricingClassObj, this.pricingObj,true)

           this.isApplyAllAlert=false;
           this.showPricingModal = false;
        
       } catch (err) {
               let body = Logger.buildRequest(
                 FILE_NAME.CREATE_PRICING,
                 "error in  onPricingFormValidated",
                 err.toString(),
                 "onPricingFormValidated",
                 LOG_TYPE.ERROR
               );
               Logger.getResponse(body);
             }
         
       }, 



    toggleAlertModal() {
      try {
       // this.showConfirmModal = !this.showConfirmModal;
        this.showAlertModal = !this.showAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in    toggleAlertModal()",
          err.toString(),
          "toggleAlertModal()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    togglePricingModal() {
      try {
        this.showPricingModal = !this.showPricingModal;
        

          updateDataEdited(true);
          renewJWT();
        
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in    togglePricingModal()",
          err.toString(),
          "togglePricingModal()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleConfirmModal() {
      try {
        this.showConfirmModal = !this.showConfirmModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in    toggleConfirmModal()",
          err.toString(),
          "toggleConfirmModal()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    resetAllSectors(pPricingClass, pPricingCells) {
      try {
     
     
        if (BaseConfiguration.isDebug) console.log("resetAllSectors");

        let pricingClassDefaultObj = {
          cell_id: null,
          pricingid: null,
          sector: null,
          class: null,
          up_down: null,
          pricing_type: null,
          pricing: {
            currencies: [
              {
                value: null,
                currency: null
              },
              {
                value: null,
                currency: null
              }
            ]
          },
          pricing_applicableto: null
        };

        if (pPricingCells && pPricingCells.length) {
          pPricingCells.forEach(cell => {
            pricingClassDefaultObj.cell_id = cell[pPricingClass].cell_id;
            pricingClassDefaultObj.pricingid = cell[pPricingClass].pricingid;
            pricingClassDefaultObj.sector = cell[pPricingClass].sector;
            pricingClassDefaultObj.class = cell[pPricingClass].class;
            cell[pPricingClass] = JSON.parse(
              JSON.stringify(pricingClassDefaultObj)
            );
          });
        }
        updateDataEdited(true);
        renewJWT()
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in resetAllSectors",
          err.toString(),
          "resetAllSectors",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    applyToAllSectors(pSelectedClass, pPricingCells, pPricingClassObj) {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("applyToAllSectors");

        if (pPricingCells && pPricingCells.length) {
          pPricingCells.forEach((cell,index) => {
            this.onPricingFormSubmit(cell[pSelectedClass], pPricingClassObj,false);
          });
        }
                 
        // this.togglePricingModal();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in applyToAllSectors",
          err.toString(),
          "applyToAllSectors",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getColumnName(pColName) {
      return pColName + "-filter";
    },

    setPricingClassObj(pSelectedPricingClassObj) {
      try {
        if (pSelectedPricingClassObj)
          this.selectedPricingClassObj = pSelectedPricingClassObj;

        if (
          pSelectedPricingClassObj &&
          pSelectedPricingClassObj.up_down &&
          pSelectedPricingClassObj.pricing_applicableto &&
          pSelectedPricingClassObj.pricing_type
        ) {
          this.pricingObj.updown = cloneData(
            this.upDownCategory.find(category => {
              return category.value == pSelectedPricingClassObj.up_down;
            })
          );
          this.pricingObj.pricingApplicableTo = cloneData(
            this.pricingApplicableTo.find(applicableTo => {
              return (
                applicableTo.value ==
                pSelectedPricingClassObj.pricing_applicableto
              );
            })
          );
          this.pricingObj.pricingType = cloneData(
            this.pricingType.find(type => {
              return type.value == pSelectedPricingClassObj.pricing_type;
            })
          );

          this.pricingObj.currencies = JSON.parse(
            JSON.stringify(pSelectedPricingClassObj.pricing.currencies)
          );
        } else {
          //list - code -
          let pricingClassDefaultObj = {};

          pricingClassDefaultObj.updown = cloneData(
            this.upDownCategory.find(category => {
              return (
                category.value == DEFAULT_PRICING.CATEGORY
              );
            })
          );
          pricingClassDefaultObj.pricingType = cloneData(
            this.pricingType.find(applicableTo => {
              return (
                applicableTo.value ==DEFAULT_PRICING.TYPE
              );
            })
          );
          pricingClassDefaultObj.pricingApplicableTo = cloneData(
            this.pricingApplicableTo.find(applicableTo => {
              return (
                applicableTo.value ==
               DEFAULT_PRICING.APPLICABLE
              );
            })
          );
          pricingClassDefaultObj.currencies = JSON.parse(
            JSON.stringify(this.currencyList)
          );

          this.pricingObj = cloneData(pricingClassDefaultObj);
        }



        // if(this.pricingObj && this.pricingObj.currencies && this.pricingObj.currencies.length)
        // {
        //   this.pricingObj.currencies.forEach(curr=>{

        //     if(typeof curr.currency=='object')
        //     { 


        //     
        //       curr.currency=curr.currency.code

        //     }
        //   })
        // }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in   setPricingClassObj",
          err.toString(),
          "setPricingClassObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onPricingFormSubmit(pSelectedPricingClassObj, pPricingObj ,isToggle) {
      try {
           if (BaseConfiguration.isDebug) console.log("onPricingFormSubmit");
        pPricingObj = JSON.parse(JSON.stringify(pPricingObj));
        // this.showPricingModal = false;

        if (pSelectedPricingClassObj && pPricingObj) {
          pSelectedPricingClassObj.up_down = pPricingObj.updown.value;

          pSelectedPricingClassObj.pricing_applicableto =
            pPricingObj.pricingApplicableTo.value;
          pSelectedPricingClassObj.pricing_type = pPricingObj.pricingType.value;
          if (
            pPricingObj &&
            pPricingObj.currencies &&
            pPricingObj.currencies.length
          ) {
            pPricingObj.currencies.forEach(currency => {
              currency.value = parseNumber(currency.value)
            
            });

          

            pSelectedPricingClassObj.pricing.currencies =
              pPricingObj.currencies;
          } else {
            pSelectedPricingClassObj.pricing.currencies = [];
          }

          pSelectedPricingClassObj = JSON.parse(
            JSON.stringify(pSelectedPricingClassObj)
          );
        }
        if(isToggle)
        this.togglePricingModal();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in   onPricingFormSubmit",
          err.toString(),
          " onPricingFormSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getRules() {
      if (BaseConfiguration.isDebug) console.log("getRules");
      let rules;
      // let rule1 = "required|onlynumber|notValidNum|";
      let rule1 = "required|onlynumber|";

      let rule2 = "max_val:100";
      rules =
        this.pricingObj.pricingType.value == PRICING_VALUE.PERCENTAGE
          ? rule1 + rule2
          : rule1;
      return rules;

      // ("_required|no_space|no_special_char|only_numbers|min_val:0|"+
      // this.pricingObj.pricingType.name=="Percentage"?"max_val:100":"")
    },

    onPricingTypeChange(pNewValue) {
      if (BaseConfiguration.isDebug) console.log("onPricingTypeChange");

      try {
        this.pricingObj.pricingType = pNewValue;
        this.pricingObj.currency = JSON.parse(
          JSON.stringify(this.currencyList)
        );
        if (this.pricingObj.pricingType.value == PRICING_VALUE.PERCENTAGE) {
          this.pricingObj.pricingApplicableTo = this.pricingApplicableTo.find(
            type => {
              return type.value != PRICING_VALUE.PER_PASSENGER;
            }
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in onPricingTypeChange",
          err.toString(),
          "onPricingTypeChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    updateUpdownCategory(pCategory) {
      if (BaseConfiguration.isDebug) console.log("updateUpdownCategory");
      try {
        this.pricingObj.updown = pCategory;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in updateUpdownCategory",
          err.toString(),
          "updateUpdownCategory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPricingApplicableToChange(pType) {
      if (BaseConfiguration.isDebug) console.log("onPricingApplicableToChange");
      try {
        this.pricingObj.pricingApplicableTo = pType;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in onPricingApplicableToChange",
          err.toString(),
          "onPricingApplicableToChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    setFromDate(pFromDate) {
      try {
        if (pFromDate && pFromDate instanceof Date) {
          if(!isPastDate(pFromDate,this.referenceDate)){
          this.showAlert(null);
          this.travelFromDate = pFromDate; //?
          }
          else
         this.showAlert(this.$t("createPricing.pastDate"));
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in  setFromDate",
          err.toString(),
          " setFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    setToDate(pToDate) {
      try {
        if (pToDate && pToDate instanceof Date) {
          if(!isPastDate(pToDate,this.referenceDate)){
          this.travelToDate = pToDate; //?
           }
          else{
          //this.travelToDate = travelToDate; //?
          this.showAlert(this.$t("createPricing.pastDate"));
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in  setToDate",
          err.toString(),
          " setToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    showAlert(val) {
      this.alertValue = val;
    },

    clearPricingCell(pPricingCell) {
      try {
        if (BaseConfiguration.isDebug) console.log("clearPricingCell");

        if (
          pPricingCell &&
          pPricingCell.up_down &&
          pPricingCell.pricing_type &&
          pPricingCell.pricing_applicableto
        ) {
          pPricingCell.up_down = null;
          pPricingCell.pricing_type = null;
          pPricingCell.pricing_applicableto = null;
          pPricingCell.pricing.currencies = [];
        }
    
        this.togglePricingModal();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in clearPricingCell",
          err.toString(),
          "clearPricingCell",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getPricingSectors(pSectorName, pAirLineCode) {
      let returnValue;
      if (BaseConfiguration.isDebug) console.log("getPricingSectors");
      try {
        let pricingSectorsReq;
        if (pSectorName != null && pAirLineCode) {
          pricingSectorsReq = apiGetPricingSectors.buildRequest(
            pSectorName,
            pAirLineCode
          );
        } else {
          throw "invalid sector name or Airline code";
        }

        if (pricingSectorsReq != null && pricingSectorsReq.sector) {
          // this.SET_PRICING_SECTOR_REQ(pricingSectorsReq);

          let pricingSectorsRes = await apiGetPricingSectors.getResponse(
            pricingSectorsReq
          );
          if (VALIDATE_SUCCESS_RES(pricingSectorsRes)) {
            returnValue = pricingSectorsRes.data.data;
            //this.SET_PRICING_SECTOR_RES(returnValue);
            this.showAlert(null);
          } else {
            let error = getErrorMessage(pricingSectorsRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getPricingSectors",
          err.toString(),
          "getPricingSectors()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return returnValue;
    },

    getPricingTableItems(pPricingClassesList, pPricingSectorsList) {
      let returnValue;
      try {
        let pricingClassDefaultObj = {
          cell_id: null,
          pricingid: null,
          sector: null,
          class: null,
          up_down: null,
          pricing_type: null,
          pricing: {
            currencies: [
              {
                value: null,
                currency: null
              },
              {
                value: null,
                currency: null
              }
            ]
          },
          pricing_applicableto: null
        };
        let lsPricingTableItems = [];
        if (
          pPricingClassesList &&
          pPricingClassesList.length &&
          pPricingSectorsList &&
          pPricingSectorsList.length
        ) {
          for (var pricingSector of pPricingSectorsList) {
            let pricingTableItem = {};

            for (var pricingClass of pPricingClassesList) {
              pricingClassDefaultObj.class = pricingClass;
              pricingTableItem[pricingClass] = JSON.parse(
                JSON.stringify(pricingClassDefaultObj)
              );

              pricingTableItem[pricingClass].sector = pricingSector.value;
            }
            pricingTableItem.sector = pricingSector.value;

            lsPricingTableItems.push(
              JSON.parse(JSON.stringify(pricingTableItem))
            );
          }
        } else {
          lsPricingTableItems = [];
        }
        returnValue = lsPricingTableItems;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getPricingTableItems",
          err.toString(),
          "getPricingTableItems()"
        );
      }
      return returnValue;
    },

    async getPricingResponseByPricingId(priObj) {
      let returnValue;

      try {
        let pricingRequest = apiGetPricingByPricingId.buildRequest(priObj);
        if (pricingRequest) {
          let pricingResponse = await apiGetPricingByPricingId.getResponse(
            pricingRequest
          );

          if (VALIDATE_SUCCESS_RES(pricingResponse)) {
            returnValue = pricingResponse.data.data;
            this.showAlert(null);
          } else {
            let error = getErrorMessage(pricingResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }

        return returnValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getPricingResponseByTierId",
          err.toString(),
          "getPricingResponseByTierId",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    buildPricingRequest(isUpdate) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("buildPricingRequest");
        let pricingReq = {};
        if (
          this.travelFromDate &&
          this.travelToDate &&
          this.sector &&
          this.sector.code &&
          this.airLine &&
          this.airLine.airline_code
        ) {
          pricingReq.name = this.pricingName;
          pricingReq.travelFromDate = formatDate(
            this.travelFromDate,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
          pricingReq.travelToDate = formatDate(this.travelToDate, DATE_TIME_FORMAT.API_DATE_FORMAT);
          pricingReq.sector = this.sector.code;
          pricingReq.airLine = this.airLine.airline_code;

          if (this.selectedPricingTier && this.selectedPricingTier.tierid) {
            pricingReq.tierId = this.selectedPricingTier.tierid;
          }
          if (isUpdate && this.pricingResponse) {
            pricingReq.pricingId = this.pricingResponse.pricingid;
            pricingReq.tierId = this.pricingResponse.tier_id;
          }

          if (this.lsPricingTableItems && this.lsPricingTableItems.length) {
            let pricingCells = JSON.parse(
              JSON.stringify(this.lsPricingTableItems)
            );
            pricingCells = this.filterPricingList(pricingCells);

            if (pricingCells && pricingCells.length) {


              
              pricingReq.b2bPricingCellss = pricingCells;
            } else {
              pricingReq.b2bPricingCellss = [];
            }
          } else {
            pricingReq.b2bPricingCellss = [];
          }

          retValue = pricingReq;
        } else {
          retValue = null;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in buildPricingRequest",
          err.toString(),
          "buildPricingRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    filterPricingList(pPricingCells) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("filterPricingList");
        if (pPricingCells && pPricingCells.length) {
          retValue = pPricingCells.filter(pricingCell => {
            let returnValue;
            Object.keys(pricingCell).forEach(pClass => {
              if (!pricingCell[pClass].up_down && pClass != "sector") {
                delete pricingCell[pClass];
              }
            });

            if (Object.keys(pricingCell).length > 1) {
              returnValue = true;
            } else {
              returnValue = false;
            }

            return returnValue;
          });
        } else {
          retValue = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in  filterPricingList",
          err.toString(),
          " filterPricingList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPricingCellStatus(pPricingCell) {
      let retValue = "Applied";
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingCell");
        if (pPricingCell && pPricingCell.up_down && pPricingCell.pricing) {
          retValue += pPricingCell.up_down == "UP" ? "(+)" : "(-) ";
          retValue += pPricingCell.pricing_type == "PERC" ? "P " : "FA ";
          retValue +=
            pPricingCell.pricing_applicableto == "PERPAX" ? "PT " : "PB ";
          if (
            pPricingCell.pricing.currencies &&
            pPricingCell.pricing.currencies.length
          ) {
            pPricingCell.pricing.currencies.forEach(currency => {
              retValue += currency.currency + " ";
              retValue += currency.value + " ";
            });
          }
        } else {
          retValue = "pricing";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getPricingCell",
          err.toString(),
          "getPricingCell",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async onCreatePricing() {
      try {
        this.isPricDetChangedAfterErr=false;
        let createPricingReq = this.buildPricingRequest();
        if (createPricingReq) {
                      this.toggleConfirmModal();

          let createPricingStatus = await this.getCreatePricingStatus(
            createPricingReq
          );

          if (createPricingStatus) {
                    this.isPricingCreatedOnce=true;

            this.pricingResponse=createPricingStatus;
             
            this.toggleAlertModal();
          }
        } else {
          throw "invalid Request";
        }
         updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in onCreatePricing",
          err.toString(),
          "onCreatePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getCreatePricingStatus(pCreatePricingReq) {
      let returnValue;

      try {
        let createPricingReq = apiCreatePricing.buildRequest(pCreatePricingReq);
        if (createPricingReq) {
          let createPricingRes = await apiCreatePricing.getResponse(
            createPricingReq
          );

          if (VALIDATE_SUCCESS_RES(createPricingRes)) {
            returnValue = createPricingRes.data.data;
            addClassToBody(COMPONENT_NAME.CREATE_PRICING)
            this.showAlert(null);
          } else {
                        addClassToBody(COMPONENT_NAME.CREATE_PRICING)

            let error = getErrorMessage(createPricingRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }


      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getCreatePricingStatus",
          err.toString(),
          "getCreatePricingStatus",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    getPricingTableFields(pPricingClassesList) {
      let returnValue;

      try {
        returnValue = [
          {
            key: "sector",
            filter: true,
            label:this.$t('createPricing.sector')
          }
        ];
        if (pPricingClassesList && pPricingClassesList.length) {
          pPricingClassesList.forEach(value => {
            returnValue.push({
              key: value,
              label: value,
              filter: true
            });
          });
        } else {
          throw " pricng class list empty";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getTableFields",
          err.toString(),
          "getTableFields()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async initTableData() {
      try {
          if (BaseConfiguration.isDebug) console.log("initTableData");
              this.onPricDetChange();             

        if (
          this.sector &&
          this.sector.code &&
          this.airLine &&
          this.airLine.airline_code
        ) {
          let pricingSectorRes = await this.getPricingSectors(
            this.sector.code,
            this.airLine.airline_code
          );

          if (
            pricingSectorRes &&
            pricingSectorRes.sectors &&
            pricingSectorRes.sectors.length &&
            pricingSectorRes.classes &&
            pricingSectorRes.classes.length
          ) {
            this.lsPricingSectors = pricingSectorRes.sectors;
            this.lsPricingClasses = pricingSectorRes.classes;
            //from drop down
            this.lsPricingTableFields = this.getPricingTableFields(
              this.lsPricingClasses
            );
            this.lsPricingTableItems = this.getPricingTableItems(
              this.lsPricingClasses,
              this.lsPricingSectors
            );
          } else {
            this.lsPricingTableItems = [];
            this.lsPricingTableFields = [];
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in initData",
          err.toString(),
          "initData()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSectorName(pSectorCode) {
      let retValue;
      if (BaseConfiguration.isDebug) console.log("getSectorName");
      try {
        let lsSectors = [
          //op
          {
            name: this.$t("sectorType.ALL"),
            code: SECTOR_TYPE.ALL
          },
          {
            name: this.$t("sectorType.DOM"),
            code: SECTOR_TYPE.DOM
          },
          {
            name: this.$t("sectorType.INT"),
            code: SECTOR_TYPE.INT
          }
        ];

        if (pSectorCode) {
          retValue = lsSectors.find(sector => {
            return sector.code == pSectorCode;
          }).name;
        } else {
          throw "invalid Sector Code";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getSectorName",
          err.toString(),
          "getSectorName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getAirLineName(pAirLineCode) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getAirLineName");

        if (
          this.GET_ALL_AIRLINE_RES &&
          this.GET_ALL_AIRLINE_RES.length &&
          pAirLineCode
        ) {
          let lsAirLine = cloneData(this.GET_ALL_AIRLINE_RES);

          let airLineObj = lsAirLine.find(airline => {
            return airline.airline_code == pAirLineCode;
          });

          if (airLineObj && airLineObj.airline_name) {
            retValue = airLineObj.airline_name;
          } else {
            retValue = pAirLineCode;
          }
        } else if (pAirLineCode) {
          retValue = pAirLineCode;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getAirLineName",
          err.toString(),
          "getAirLineName",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async setPricingDetails(pPricingRes) {
      try {
        if (BaseConfiguration.isDebug) console.log(" getPricingDetails");
        this.pricingName = pPricingRes.display_text;
        this.sector = {
          name: this.getSectorName(pPricingRes.sector_type),
          code: pPricingRes.sector_type
        };
        this.airLine = {
          airline_name: this.getAirLineName(pPricingRes.airline_code),
          airline_code: pPricingRes.airline_code
        };
        this.travelFromDate = new Date(pPricingRes.travel_period_from);
        this.travelToDate = new Date(pPricingRes.travel_period_to);

        await this.initTableData();
        if (this.lsPricingTableItems && this.lsPricingTableItems.length) {
          this.lsPricingTableItems.forEach(item => {
            pPricingRes.b2bPricingCellss.forEach(cell => {
              if (item.sector == cell.sector) {
                Object.keys(item).forEach(pricingClass => {
                  if (cell[pricingClass]) {
                    item[pricingClass] = cloneData(cell[pricingClass]);
                    
                    if(item[pricingClass]&&item[pricingClass].pricing&&item[pricingClass].pricing.currencies&&item[pricingClass].pricing.currencies.length!= this.currencyList.length){
                          this.currencyList.forEach(currObj => {
                            let currecyExist=false;
                         loop:item[pricingClass].pricing.currencies.forEach(pricingCurr => {
                             if(currObj.currency==pricingCurr.currency){
                               currecyExist=true;
                               return true;
                             }

                             });
                             if(!currecyExist){
                             item[pricingClass].pricing.currencies.push(currObj);
                             }
                              });
                    }
                  }
                });
              }
            });
          });

          this.lsPricingTableItems = this.lsPricingTableItems;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in   setPricingDetails",
          err.toString(),
          "setPricingDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getCurrencyList(pSCurrencyLs) {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyList");
        let retValue;

        let currencyRequest = apiGetOrgCurrencyLs.buildRequest();

        if (currencyRequest) {
           let currencyResponse;
          if(pSCurrencyLs&&pSCurrencyLs.data&&pSCurrencyLs.data.data&&pSCurrencyLs.data.data[0]&&pSCurrencyLs.data.data[0].currency_code&&pSCurrencyLs.data.data[0].currency_code.constructor==String){//this was called in sidebar this.GET_ORG_CURRENCY_RES //temp
             currencyResponse= JSON.parse(JSON.stringify( ( this.GET_ORG_CURRENCY_RES)));

          }else
          {
            currencyResponse = await apiGetOrgCurrencyLs.getResponse(
            currencyRequest
          );
          }
          if (VALIDATE_SUCCESS_RES(currencyResponse)) {
            retValue = JSON.parse(JSON.stringify( currencyResponse.data.data));
            this.showAlert(null);
          } else {
            // this.showAlert = true;

            let error = getErrorMessage(currencyResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getCurrencyList",
          err.toString(),
          "getCurrencyList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getCurrencies(currencyList) {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencies");
        let currList = [];
        if (currencyList && currencyList.length)
          for (let cList = 0; cList < currencyList.length; cList++) {
            const cListItem = currencyList[cList];

            let currObj = {
              value: 0,
              currency: cListItem.currency_code
            };
            currList.push(currObj);
          }
        return currList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getCurrencies",
          err.toString(),
          "getCurrencies",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    navToManagePricing(isGoBack) {//after updating dont need to go back - client asking us to stay same page after updating
      try {
        if (BaseConfiguration.isDebug) console.log("mnavToManagePricing");
        this.showAlertModal = false;
        this.showConfirmModal = false;
        if(isGoBack) //client asking us to stay same page after updating
          goBack(); 
        //this.scrollToTop();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in navToManagePricing",
          err.toString(),
          "navToManagePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async updatePricng() {
      try {
          this.isPricDetChangedAfterErr=false;
        let updatePricingReq = this.buildPricingRequest(true);
        updatePricingReq = apiUpdatePricing.buildRequest(updatePricingReq);
        if (updatePricingReq) {
                      this.toggleConfirmModal();

          let updatePricingRes = await apiUpdatePricing.getResponse(
            updatePricingReq
          );

          if (VALIDATE_SUCCESS_RES(updatePricingRes)) {
            addClassToBody(COMPONENT_NAME.CREATE_PRICING);
            this.showAlert(null);
            // this.toggleConfirmModal();
            this.toggleAlertModal();
          } else {
               addClassToBody(COMPONENT_NAME.CREATE_PRICING);

            this.showAlert(null);
            // this.toggleConfirmModal();
            let error = getErrorMessage(updatePricingRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
         this.isPricingCreatedOnce=true;
           updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in updatePricing",
          err.toString(),
          "updatePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": this.$t("flightDatePicker.checkIn"),
          "check-out": this.$t("flightDatePicker.checkOut"),
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },
  async created() {
    if (BaseConfiguration.isDebug) console.log("created");

    try {
      this.currencyList = this.getCurrencies(await this.getCurrencyList( cloneDeep( this.GET_ORG_CURRENCY_RES)))

      if (this.selectedPricingObj) {
        let pricingObj = JSON.parse(JSON.stringify(this.selectedPricingObj));

        this.pricingResponse = await this.getPricingResponseByPricingId(
          pricingObj
        );

        if (this.pricingResponse) {
          await this.setPricingDetails(this.pricingResponse);
        }
      } else {
        this.travelFromDate = new Date();
        this.travelToDate = addDays(this.travelFromDate, 2);
      }
      this.referenceDate = this.travelFromDate;
      /* if(this.pricingObj)
                {
                 this.pricingObj.updown=this.updateUpdownCategory[0];
                   this.pricingObj.pricingType =this.pricingType[0];
                   this.pricingObj.pricingApplicableTo =this.pricingApplicableTo[1];
                } */

      this.upDownCategory = [
        {
          name: this.$t("createPricing.UP"),
          value: PRICING_VALUE.MARK_UP,
          code: "1"
        },
        {
          name: this.$t("createPricing.DOWN"),
          value: PRICING_VALUE.MARK_DOWN,
          code: "2"
        }
      ];

      this.pricingType = [
        {
          name: this.$t("createPricing.PERC"),
          value: PRICING_VALUE.PERCENTAGE,
          code: "1"
        },
        {
          name: this.$t("createPricing.FIX"),
          value: PRICING_VALUE.FIXED_AMOUNT,
          code: "2"
        }
      ];
      this.pricingApplicableTo = [
        {
          name: this.$t("createPricing.PERPAX"),
          value: PRICING_VALUE.PER_PASSENGER,

          code: "1"
        },
        {
          name: this.$t("createPricing.PERBOOK"),
          value: PRICING_VALUE.PER_BOOKING,

          code: "2"
        }
      ];

      //  this.pricingObj.currencies = JSON.parse(
      //   JSON.stringify(this.currencyList)
      // );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.CREATE_PRICING,
        "error in  Creating pricing object",
        err.toString(),
        "Created",
        LOG_TYPE.ERROR
      );

      Logger.getResponse(body);
    }
  },
    beforeCreate() {    
   addClassToBody(COMPONENT_NAME.CREATE_PRICING);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>
<style scoped>
.date-picker-box-shadow {
    max-width: none;
}
.pc {
  color: #00ca9d;
  font-weight: bolder;
}
</style>
